import { render, staticRenderFns } from "./PrintFormatFilter.vue?vue&type=template&id=388afc8d&"
import script from "./PrintFormatFilter.vue?vue&type=script&lang=js&"
export * from "./PrintFormatFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports